import styled from 'styled-components';

import { ICON_RESET } from '@ui-component-library/styles/components.reset';

export const S = {
  IconWrapper: styled.div<{
    width: number;
    height: number;
  }>`
    ${ICON_RESET}

    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${({ width }) => width}px;
    min-height: ${({ height }) => height}px;
  `
};
